import { render } from "./AssignOrder.vue?vue&type=template&id=62add51a"
import script from "./AssignOrder.vue?vue&type=script&lang=js"
export * from "./AssignOrder.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__